import React, {useEffect, Suspense} from "react";
import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";

import Home from "./pages/Home";
import Report2025 from "./pages/Report2025";
import Elevate from "./pages/Elevate";

import Header from "./compnents/header";

import {useTranslation} from "react-i18next";

const STANDALONE_ROUTES = ["/report2025", "/elevate"];

function AppShell() {
  const {i18n} = useTranslation();
  const {pathname} = useLocation();
  const isStandalone = STANDALONE_ROUTES.includes(pathname);

  useEffect(() => {
    document.documentElement.setAttribute("dir", i18n.language === "ar" ? "rtl" : "ltr");
  }, [i18n.language]);

  return (
    <div dir={isStandalone ? "ltr" : i18n.language === "ar" ? "rtl" : "ltr"}>
      {!isStandalone && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/report2025" element={<Report2025 />} />
        <Route path="/elevate" element={<Elevate />} />
      </Routes>
      {!isStandalone && (
        <a href="https://wa.me/971504630141" target="_blank" rel="noopener noreferrer" className="fixed bottom-5 right-5 z-50">
          <img src="/wth.png" alt="WhatsApp" className="h-14 w-14" />
        </a>
      )}
    </div>
  );
}

const App = () => {
  return (
    <Suspense fallback={<div></div>}>
      <Router>
        <AppShell />
      </Router>
    </Suspense>
  );
};

export default App;
